import Header from "../../landingPage/Header";
import Footer from "../../landingPage/Footer";
import { Outlet } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { getDocs, query, where } from "firebase/firestore";
// import { paymentCollectionRef } from "../../../config/firebaseConfig";
// import { fetchSchoolParticipants } from "../../../redux/features/schoolParticipantsSlice";

const SchoolDashboardLayout = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  // const dispatch = useDispatch();

  const { userDetails: schoolDetails, loading: schoolDetailsLoading } =
    useSelector((state) => state.auth);

  console.log(schoolDetails);

  // fetch participants registered for the school
  // const fetchParticipants = useCallback(() => {
  //   try {
  //     schoolDetails &&
  //       dispatch(fetchSchoolParticipants({ schoolId: schoolDetails?.id }))
  //         .unwrap()
  //         .catch((error) => {
  //           throw new Error(error.message);
  //         });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, [dispatch, schoolDetails]);

  // useEffect(() => {
  //   const unsub = schoolDetails ? fetchParticipants() : () => {};
  //   return () => unsub?.();
  // }, [schoolDetails, fetchParticipants]);

  const [totalFeeCollected, setTotalFeeCollected] = useState(0);
  // useEffect(() => {
  //   const schoolId = schoolDetails?.id;
  //   const fetchPayments = async () => {
  //     const q = query(paymentCollectionRef, where("schoolId", "==", schoolId));
  //     try {
  //       const payments = [];
  //       const querySnapshot = await getDocs(q);
  //       querySnapshot.forEach((doc) => {
  //         payments.push({ ...doc.data(), id: doc.id });
  //       });

  //       const totalFeeINR = payments?.reduce((acc, curr) => {
  //         return curr?.currency === "INR" ? (acc += curr?.amount) : 0;
  //       }, 0);
  //       const totalFeeUSD = payments?.reduce((acc, curr) => {
  //         return curr?.currency === "USD" ? (acc += curr?.amount) : 0;
  //       }, 0);

  //       setTotalFeeCollected({
  //         totalFeeINR,
  //         totalFeeUSD,
  //       });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   schoolDetails && fetchPayments();
  // }, [schoolDetails]);

  return (
    <div>
      <Header placement="dashboard" dashboard="school" />
      <div className="mt-40">
        <Outlet
          context={{
            schoolDetails,
            schoolDetailsLoading,
            totalFeeCollected,
          }}
        />
      </div>
      <Footer />
    </div>
  );
};

export default SchoolDashboardLayout;
